import { pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';

export const ExampleButtonLabel = styled.p`
  margin: auto 0 0 0.25rem;
  ${pickThemeFontStyles('12', '26')}
`;
